import { render, staticRenderFns } from "./ReportCompetencyIDP.vue?vue&type=template&id=ae7f3a9a&scoped=true"
import script from "./ReportCompetencyIDP.vue?vue&type=script&lang=js"
export * from "./ReportCompetencyIDP.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ae7f3a9a",
  null
  
)

export default component.exports